import { useState } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { AlertDialog } from '@zurich/ui/legacy/components';
import { isRecommendedBrowser } from '~/utils';

export const RecommendedBrowserNotice = () => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(!isRecommendedBrowser());
  const [buttonText, setButtonText] = useState(
    t('vsga:welcome.browserDetectionWarning.copyLink')
  );

  const handleContinue = async () => {
    await navigator.clipboard.writeText(window.location.href);
    setButtonText(t('common:copySuccessful'));
    setTimeout(() => {
      setButtonText(t('vsga:welcome.browserDetectionWarning.copyLink'));
    }, 2000); // Reset to original "Kopieren" text after 2 seconds to show that the content has been copied
  };

  return (
    <AlertDialog
      description={t('vsga:welcome.browserDetectionWarning.description')}
      continueText={buttonText}
      onContinue={handleContinue}
      cancelText={t('vsga:welcome.browserDetectionWarning.stayHere')}
      onCancel={() => setOpen(false)}
      open={open}
      title=""
    />
  );
};
